import React from 'react';
import styled from 'styled-components';

import {containerStyles} from 'styles/shared';

const PaymentContainer = styled.div`
  height: 40.6rem;
  padding: 5rem;
  margin-bottom: 8.8rem;
  ${containerStyles};
`;

function PaymentComponent() {
  return <PaymentContainer></PaymentContainer>;
}

export default PaymentComponent;
